export default {
  order: 4,
  layerGroupId: 'GROUP_LC',
  dataLayer: {
    id: 'TREE_COVER',
    order: 4,
    type: 'remoteDataLayer',
    uuid: '2569adca-ef87-42c4-a153-57c5e8ba0ef7',
    groupId: 'GROUP_LC',
  },
  layer: {
    metadata: {
      metadata: null,
      legendConfig: {
        name: {
          en: 'Tree cover',
          fr: 'Couvert arboré',
          es: 'cobertura arbórea',
          pt: 'cobertura arbórea',
          id: 'Tutupan Pohon',
          zh: '森林覆盖',
          ka: 'ტყის საფარი',
        },
        type: 'basic',
        items: [
          {
            outlineColor: '#555555',
            color: '#2DBC27',
            name: {
              en: 'Tree cover',
              fr: 'Couvert arboré',
              es: 'cobertura arbórea',
              pt: 'cobertura arbórea',
              id: 'Tutupan Pohon',
              zh: '森林覆盖',
              ka: 'ტყის საფარი',
            },
          },
        ],
      },
      interactionConfig: {},
    },
    id: 'TREE_COVER',
    type: 'tree-cover',
    url: ' https://earthengine.google.org/static/hansen_2014/gfw_loss_tree_year_{thresh}_2014/{z}/{x}/{y}.png',
    technicalName: 'tree_cover',
    opacity: 0.8,
    label: {
      en: 'Tree cover',
      fr: 'Couvert arboré',
      es: 'Cobertura arbórea',
      pt: 'cobertura arbórea',
      id: 'Tutupan Pohon',
      zh: '森林覆盖',
      ka: 'ტყის საფარი',
    },
    sublabel: {
      en: '(2000, 30m global, Hansen/UMD/Google/USGS/NASA)',
      fr: '(2000, 30 m, mondiale, Hansen/UMD/Google/USGS/NASA)',
      es: '(2000, 30 m, global, Hansen/UMD/Google/USGS/NASA)',
      pt: '(2000, 30 m global, Hansen/UMD/Google/USGS/NASA)',
      id: '(2000, 30m global, Hansen/UMD/Google/USGS/NASA)',
      zh: '(2000年, 30米 全球覆盖, 汉森/马里兰大学/谷歌/美国地质测量局(USGS)/美国宇航局(NASA))',
      ka: '(2000 წ, 30მ გლობალური, Hansen/UMD/Google/USGS/NASA)',
    },
  },
  isMetadataError: false,
  isError: false,
};
